import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
    >
      <div className="container-fluid">
        {/* 17th vedio */}
        <Link className="navbar-brand" to="/Home">
          {props.title}
        </Link>
          {/* <a className="navbar-brand" href="#">
          {props.title}
        </a> */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link " aria-current="page" to="/Home">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                {props.aboutText}
              </Link>
            </li>
          </ul>
           
           {/* <div className="d-flex">
                 <div className="bg-primary rounded mx-2" onClick={()=>{props.toggleMode('primary')}} style={{height : '30px', width: '30px', cursor:'pointer'}}> </div>
                 <div className="bg-danger rounded mx-2" onClick={()=>{props.toggleMode('primary')}} style={{height : '30px', width: '30px', cursor:'pointer'}}> </div>
                 <div className="bg-success rounded mx-2" onClick={()=>{props.toggleMode('primary')}} style={{height : '30px', width: '30px', cursor:'pointer'}}> </div>
                 <div className="bg-warning rounded mx-2" onClick={()=>{props.toggleMode('primary')}} style={{height : '30px', width: '30px', cursor:'pointer'}}> </div>
           </div> */}
          
          {/* Theme Circles */}
          {/* <div className="d-flex align-items-center">
            <button
              className="rounded-circle mx-1 border border-dark"
              // style={{ width: "30px", height: "30px", backgroundColor: "red" }}
              // onClick={() => props.changeTheme("red")}
            ></button>
            <button
              className="rounded-circle mx-1 border border-dark"
              // style={{ width: "30px", height: "30px", backgroundColor: "blue" }}
              // onClick={() => props.changeTheme("blue")}
            ></button>
            <button
              className="rounded-circle mx-1 border border-dark"
              // style={{ width: "30px", height: "30px", backgroundColor: "green" }}
              // onClick={() => props.changeTheme("green")}
            ></button>
            <button
              className="rounded-circle mx-1 border border-dark"
              // style={{ width: "30px", height: "30px", backgroundColor: "yellow" }}
              // onClick={() => props.changeTheme("yellow")}
            ></button>
          </div> */}

          {/* Dark Mode Toggle */}
          <div
            className={`form-check form-switch text-${
              props.mode === "light" ? "dark" : "light"
            } mx-3`}
          >
            <input
              className="form-check-input"
               onClick={props.toggleMode}
              //onClick={ () => {props.toggleMode(null)}}
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
              {props.text}
            </label>
          </div>
        </div>
      </div>
    </nav>
  );
}

// PropTypes Validation
Navbar.propTypes = {
  title: PropTypes.string,
  aboutText: PropTypes.string,
  toggleMode: PropTypes.func.isRequired,
  changeTheme: PropTypes.func.isRequired, // Ensure function is required
};

// Default Props
Navbar.defaultProps = {
  title: "Home",
  aboutText: "About Us",
};
